import { SalesChannelCategoryMappingImportPage } from "@/features/sales-channel-category-mapping/pages/SalesChannelCategoryMappingImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/sales-channel-category-mapping/import",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["sales_channel_category_groups.create"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: SalesChannelCategoryMappingImportPage,
});
